import React from "react";
import { Navigate } from "react-router-dom";

export const RoleProtectedRoute = ({ children, allowedRoles }) => {
    const token = localStorage.getItem("token");
    const rolId = localStorage.getItem("rol_id");

    if (!token || !allowedRoles.includes(parseInt(rolId))) {
        return <Navigate to="/login" />;
    }

    return children;
};
